// removed by extract-text-webpack-plugin
module.exports = {"block":"restore-change__block-3NCEp","title":"restore-change__title-3DrEV","field":"restore-change__field-BWL_5","description":"restore-change__description-1-atW","submit":"restore-change__submit-2nwOb blocks__blue-tjpdI blocks__button-1iODk"};


//////////////////
// WEBPACK FOOTER
// ./components/auth/restore-change/restore-change.css
// module id = 793
// module chunks = 0